<layout>
<div class="global_insets global_background" style="min-height: 80vh">
    <div *ngIf="isSuper">
    <mat-tab-group mat-align-tabs="center" 
    (selectedIndexChange)="updateIndex($event)"
    [selectedIndex]="selectedTab.value" >

        <mat-tab label={{_tabs[0]}}>
            <ng-template matTabContent>
                <mat-form-field *ngIf="!!profile && !!organization" appearance="fill">
                    <mat-label>Organization</mat-label>
                    <mat-select 
                    (selectionChange)="orgnizationChange($event)"
                    [(value)]="organization">
                        <mat-option *ngFor="let o of orgs" [value]="o">
                        {{o?.name}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>

                <!-- name and avatar -->
                <div class="btwrw padding" >
                    <div>
                    <h1>{{organization?.name}}</h1>
                    <h4>EntityId/Shortname: <strong>{{organization?.entityId}}</strong></h4>
                    <h4 *ngIf="!!organization?.organizer">Organizer : {{organization?.organizer?.name}} | 
                        <a target="_blank" href="https://console.firebase.google.com/u/0/project/studies-151020/firestore/data/Profiles/{{organization?.organizer?.uid}}">{{organization?.organizer?.uid}}</a></h4>
                    <h4> Zips:</h4><div class="ziplist"> <span class="zipcode" *ngFor="let zip of organization?.zips">{{zip}}</span> </div>
                    </div>

                    <div class=avatar>{{profile.firstname | firstLetter}} {{profile.lastname | firstLetter}}</div>
                </div>

                <mat-tab-group mat-align-tabs="center"  >
            
                    <mat-tab label="Instructors">
                        <ng-template matTabContent>
                        <app-my-school-instructor 
                            name="{{profile?.firstname + ' ' + profile?.lastname}}"
                            orgName="{{organization?.name}}"
                            superAdmin="{{isSuper}}"
                            entityId="{{organization?.entityId}}"
                            orgId="{{organization?.id}}">
                        </app-my-school-instructor>

                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Contacts">
                        <ng-template matTabContent>    
                            <app-contacts-page 
                                entityId="{{organization?.entityId}}"
                                orgId="{{organization?.id}}">
                            </app-contacts-page>
                        </ng-template>
                    </mat-tab>
                    <mat-tab label="Invitations">
                        <app-invitations
                            name="{{profile?.firstname + ' ' + profile?.lastname}}"
                            orgName="{{organization?.name}}"
                            superAdmin="{{isSuper}}"
                            entityId="{{organization?.entityId}}"
                            org="{{organization?.id}}">
                        >

                        </app-invitations>
                    </mat-tab>
                </mat-tab-group>
        </ng-template>
        </mat-tab>
        <mat-tab label={{_tabs[1]}}>
            <ng-template matTabContent>
                <table mat-table [dataSource]="orgs" matSort class="mat-elevation-z8 stretch" >
        
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                      <td mat-cell *matCellDef="let org"> <a target="_blank" href="https://console.firebase.google.com/u/0/project/studies-151020/firestore/data/Organizations/{{org.id}}">{{org?.name}}</a> </td>
                    </ng-container>
                
                 <ng-container matColumnDef="entityId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> EntityId/Shortname </th>
                        <td mat-cell *matCellDef="let org"> {{org?.entityId}} </td>
                      </ng-container>
                   
              
                    <ng-container matColumnDef="zips">
                      <th mat-header-cell *matHeaderCellDef> Zipcodes </th>
                      <td mat-cell *matCellDef="let org"><div class="ziplist"> <span class="zipcode" *ngFor="let zip of org?.zips">{{zip}}</span> </div> </td>
                    </ng-container>
                    <ng-container matColumnDef="outreach">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header > In Outreach </th>
                        <td mat-cell *matCellDef="let org">
                            <mat-checkbox
                                disabled
                                [checked]="!!org?.outreach_id">
                            </mat-checkbox>
                        </td>
                      </ng-container>
                    <ng-container matColumnDef="pastor">
                      <th mat-header-cell *matHeaderCellDef > Pastor </th>
                      <td mat-cell *matCellDef="let org">
                          <p>{{org?.pastor?.name}}</p>
                          <p>{{org?.pastor?.email}}</p>
                          <p>{{org?.pastor?.phone}}</p>
                        
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="organizer">
                        <th mat-header-cell *matHeaderCellDef> Organizer </th>
                        <td mat-cell *matCellDef="let org">
                            <p>{{org?.organizer?.name}}</p>
                            <p>{{org?.organizer?.email}}</p>
                            <p>{{org?.organizer?.phone}}</p>
                          
                          </td>
                      </ng-container>
            
                    <ng-container matColumnDef="address">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
                      <td mat-cell *matCellDef="let org">{{org?.address}}</td>
                    </ng-container>

                    <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> City </th>
                        <td mat-cell *matCellDef="let org">{{org?.city}}</td>
                      </ng-container>
            
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>


            </ng-template>
        </mat-tab>
        <mat-tab label={{_tabs[2]}}>
            <app-org-activity
                superAdmin={{isSuper}}
            >

             </app-org-activity>
        </mat-tab>
        <mat-tab label={{_tabs[3]}}>
            <app-church-applications
                superAdmin={{isSuper}}
            >

            </app-church-applications>
        </mat-tab>

        <mat-tab label={{_tabs[4]}}>
            <app-admin-contacts
                superAdmin={{isSuper}}
            >
            </app-admin-contacts>
        </mat-tab>
        <mat-tab label={{_tabs[5]}}>
            <app-admin-languages
            superAdmin={{isSuper}}
            >
            </app-admin-languages>
        </mat-tab>
    </mat-tab-group>
    </div>
    
</div>
</layout>